export default class RiskProfileData {
  static questions = [
    {
      id: 1,
      question: 'How do you respond to fluctuations in the market?',
      answers: [
        {
          value: 1,
          text: 'I am very concerned when my investments lose value and I am tempted to sell',
        },
        {
          value: 2,
          text: 'If an investment loses 5% over a quarter, I am likely to sell and invest elsewhere',
        },
        {
          value: 4,
          text: 'I usually wait until I have watched the performance of an investment for at least a year before making changes',
        },
        {
          value: 5,
          text: 'Even if poor market conditions result in losses of up to 20% in a given year, I try and follow a long term investment plan'
        }
      ]
    },
    {
      id: 2,
      question: 'What is your attitude towards risk when targeting growth on your capital?',
      answers: [
        {
          value: 1,
          text: 'I am a conservative investor and comfortable to see my targeted return after 1 years'
        },
        {
          value: 2,
          text: 'I am a moderate investor and comfortable to only see my targeted return after 3 years'
        },
        {
          value: 4,
          text: 'I am a moderate-aggressive investor and comfortable to only see my targeted return after 5 years'
        },
        {
          value: 5,
          text: 'I am an aggressive investor and comfortable to only see my targeted return after 7 years'
        }
      ]
    },
    {
      id: 3,
      question: 'How likely are you to at short notice, withdraw money from the investment?',
      answers: [
        {
          value: 5,
          text: 'Not likely'
        },
        {
          value: 1,
          text: 'Very likely'
        },
        {
          value: 3,
          text: 'Possibly'
        }
      ]
    },
    {
      id: 4,
      question: 'How far would the value of your portfolio have to fall in one year for you to be concerned?',
      answers: [
        {
          value: 5,
          text: 'I would not become concerned because I am a long term investor'
        },
        {
          value: 4,
          text: 'More than 15%'
        },
        {
          value: 3,
          text: 'More than 10%'
        },
        {
          value: 2,
          text: 'More than 5%'
        },
        {
          value: 1,
          text: "I'm sensitive to any capital movements"
        }
      ]
    },
    {
      id: 5,
      question: 'If you invested R1,000,000 today and in 6 months the value was R800,000 - what would you do?',
      answers: [
        {
          value: 1,
          text: 'I would withdraw my funds as I cannot afford to put further capital at risk'
        },
        {
          value: 3,
          text: 'Nothing as I am a long term investor and understand that a correctly managed portfolio will deliver a return on investment in the medium to long term'
        },
        {
          value: 5,
          text: 'I would invest further because the market evidences an even better proposition today than it did before'
        }
      ]
    }
  ]
}
